import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "./OrganizationDetails.css";
import { useLocation } from "react-router-dom";
import config from "../../config";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Greeting from "../greeting/Greeting";
import { BANK_LIST } from "../constants/dropdownConstants";
import SuccessPopup from "../../components/common/SuccessPopup";
import ErrorPopup from "../../components/common/ErrorPopup";
import { GrNotification } from "react-icons/gr";


const OrganizationDetail = () => {
  const [successPopup, setSuccessPopup] = useState(null);
  const [errorPopup, setErrorPopup] = useState(null);
  const location = useLocation();
  const signupData = location.state?.signupData;
  const [bankNames, setBankNames] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [error, setError] = useState("");

  const role = signupData.role;
  const name = signupData.companyName;
  const validationSchema = Yup.object({
    organizationName: Yup.string()
      .required("Organization Name is required.") // Required field
      .matches(
        /^[a-zA-Z\s\-'.]*$/,
        "Organization Name can only contain alphabets, spaces, hyphens, or apostrophes, period."
      ) // Custom regex validation
      .max(100, "Organization Name must not exceed 100 characters.") // Max length
      .test(
        "no-leading-trailing-spaces",
        "Leading and trailing spaces are not allowed",
        (value) => value?.trim() === value
      ), // No leading/trailing spaces
    phoneNumber: Yup.string()
      .matches(/^\+91\s\d{10}$/, "Phone number must be 12 digits.")
      .required("Phone Number is required."),
    emailAddress: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address."
      )
      .required("Email ID is required."),
    numberOfEmployees: Yup.number()
      .required("Number of Employees is required")
      .positive("Company size is required."),
    websiteUrl: Yup.string()
      .nullable()
      .notRequired()
      .url("Please enter a valid URL format company website.")
      .max(255, "Website URL cannot exceed 255 characters."),
    address: Yup.string()
      .required("Address Line is required.") // Required field
      .max(100, "Address Line cannot exceed 100 characters."),
    city: Yup.string()
      .required("City is required.")
      .max(50, "City cannot exceed 50 characters."),
    district: Yup.string()
      .required("District is required.")
      .max(50, "City cannot exceed 50 characters."),
    pincode: Yup.number()
      .typeError("Pincode must be a number")
      .integer("Pincode must be an integer")
      .test(
        "len",
        "Pincode must be exactly 6 digits",
        (val) => val && val.toString().length === 6
      )
      .required("Pincode is required"),
    pan: Yup.string()
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN format"),
    gstin: Yup.string()
      .matches(/^[a-zA-Z0-9]{15}$/, "GSTIN must be 15 alphanumeric characters"),
    pfNumber: Yup.string()
      .matches(
        /^[A-Za-z0-9]{15}$/,
        "PF Registration Number must be exactly 15 alphanumeric characters."
      ), // ✅ comma added

    esiNumber: Yup.string()
      .matches(
        /^[A-Za-z0-9]{17}$/,
        "ESI Registration Number must be exactly 17 alphanumeric characters."
      ),
    branchName: Yup.string()
      .required("Bank Branch Name is required.")
      .matches(
        /^[A-Za-z\s]*$/,
        "Bank Branch Name can contain only alphabets and spaces."
      )
      .max(100, "Bank Branch Name must not exceed 100 characters.")
      .test(
        "no-leading-trailing-spaces",
        "Leading and trailing spaces are not allowed",
        (value) => value?.trim() === value
      ), // ✅ comma added

    accountHolderName: Yup.string()
      .required("Account Holder Name is required.")
      .matches(
        /^[A-Za-z\s]*$/,
        "Account Holder Name can contain only alphabets and spaces."
      )
      .max(50, "Account Holder Name must not exceed 50 characters.")
      .test(
        "no-leading-trailing-spaces",
        "Leading and trailing spaces are not allowed",
        (value) => value?.trim() === value
      ),
    accountNumber: Yup.string()
      .required("Account Number is required.")
      .matches(/^[0-9]+$/, "Only numbers are allowed")
      .min(9, "Minimum 9 digits required")
      .max(18, "Maximum 18 digits allowed"),

    confirmAccountNumber: Yup.string()
      .required("Confirm Account Number is required.")
      .oneOf([Yup.ref("accountNumber")], "Account Number does not match"),
    country: Yup.string()
      .required("Country is required."),

    state: Yup.string()
      .required("State is required."),

    bankName: Yup.string()
      .required("Bank Name is required."),
    ifsc: Yup.string()
      .required("IFSC Code is required.")
      .matches(
        /^[A-Z]{4}0[A-Z0-9]{6}$/,
        "Invalid IFSC Code format."
      )




  });

  console.log("Received Signup Data:", signupData);

  const initialValues = {
    organizationName: signupData.companyName,
    phoneNumber: "+91 " + signupData.phoneNumber,
    emailAddress: signupData.emailId,
    numberOfEmployees: "",
    websiteUrl: "",
    address: "",
    city: "",
    district: "",
    state: "",
    pincode: null,
    country: "",
    pan: "",
    gstin: "",
    esiNumber: "",
    pfNumber: "",
    bankName: "",
    branchName: "",
    accountHolderName: "",
    accountNumber: "",
    confirmAccountNumber: "",
    ifsc: "",
  };

  const handleSubmit = async (values) => {
    console.log("Form values:", values);

    const requestBody = {
      signupData,
      organisationName: values.organizationName,
      phoneNumber: parseInt(
        values.phoneNumber.replace(/\D/g, "").slice(-10),
        10
      ),
      emailAddress: values.emailAddress,
      password: signupData.password,
      companyWebsite: values.websiteUrl,
      companySize: values.numberOfEmployees,
      address: values.address,
      city: values.city,
      district: values.district,
      state: values.state,
      pincode: values.pincode,
      country: values.country,
      panNumber: values.pan,
      gstNumber: values.gstin,
      pfNumber: values.pfNumber,
      esiNumber: values.esiNumber,
      bankName: values.bankName,
      accountHolderName: values.accountHolderName,
      accountNumber: values.accountNumber,
      ifsc: values.ifsc,
      branch: values.branchName,
      userEmailId: values.emailAddress,
      userPassword: signupData.password,
      userPhoneNumber: signupData.phoneNumber,
      firstName: signupData.firstName,
      lastName: signupData.lastName,
      role: signupData.role,
    };

    try {
      const response = await fetch(
        `${config.API_BASE_URL}${config.ORG_SIGNUP_ENDPOINT}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
          credentials: "include",
        }
      );

      console.log("Raw response:", response);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("API call failed:", errorText);
        setErrorPopup(
          `Server error: ${response.status} ${response.statusText}`
        );
        return;
      }

      const text = await response.text(); // Read as plain text first
      console.log("Raw response text:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (parseError) {
        console.error("Failed to parse JSON:", parseError);
        setErrorPopup("Unexpected response format from server.");
        return;
      }

      console.log("Organization details submitted successfully:", data);

      // Update local storage with final registration data
      localStorage.setItem("userEmail", values.emailAddress);
      localStorage.setItem("phoneNumber", values.phoneNumber.replace(/\D/g, "").slice(-10));

      setSuccessPopup("Organization registered successfully!");
      //window.location.href = "/signin";
    } catch (error) {
      console.error("Network or server error:", error);
      setErrorPopup("Something went wrong. Check your internet and try again.");
    }
  };

  // Fetch Countries once on mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await fetch(
          `${config.API_BASE_URL}${config.COUNTRY_ENDPOINT}`,
          {
            headers: { "Content-Type": "application/json" },
            credentials: "include",
          }
        );
        if (!res.ok) throw new Error("Failed to fetch countries");
        const data = await res.json();
        const countriesList = Array.isArray(data) ? data : (data?.body || data?.data || []);
        setCountries(countriesList);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchCountries();
  }, []);

  // Fetch States when country changes
  useEffect(() => {
    if (!selectedCountry) return;

    const fetchStates = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}${config.STATE_ENDPOINT}?countryId=${selectedCountry}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
          }
        );
        if (!response.ok) throw new Error("Failed to fetch states");
        const data = await response.json();
        const statesList = Array.isArray(data) ? data : (data?.body || data?.data || []);
        setStates(statesList);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchStates();
  }, [selectedCountry]);

  // Fetch Districts when state changes
  useEffect(() => {
    if (!selectedState) return;

    const fetchDistricts = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}${config.DISTRICT_ENDPOINT}?stateId=${selectedState}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
          }
        );
        if (!response.ok) throw new Error("Failed to fetch districts");
        const data = await response.json();
        const districtsList = Array.isArray(data) ? data : (data?.body || data?.data || []);
        setDistricts(districtsList);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchDistricts();
  }, [selectedState]);



  return (
    <div className='organization-container'>
      {successPopup && (
        <SuccessPopup
          message={successPopup}
          onClose={() => {
            setSuccessPopup(null);
            window.location.href = "/signin"; // redirect after success
          }}
        />
      )}
      {errorPopup && (
        <ErrorPopup message={errorPopup} onClose={() => setErrorPopup(null)} />
      )}

      {/* Sidebar */}
      <div className='sidebar'>
        <div className='company-logo'>
          <img src='/icons/Layer.png' alt='' className='company-logo-icon' />
        </div>
        <div className='menu'>
          <span className='menu-item active'>Organisation Details</span>
        </div>
        <button className='queries-button'>Queries</button>
      </div>

      {/* Main Content */}
      <div className='content'>
        <header className='header'>
          <div>
            <div>
              <Greeting name={name} />
            </div>
          </div>
          <div className='user-profile'>
            <span className='notification-icon'><GrNotification />
            </span>
            <img src='icons/user.png' alt='User' className='user-image' />
            <div className='user-info'>
              <span className='user-role'>{role}</span>
              <span className='user-name'>{name}</span>
            </div>
          </div>
        </header>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, setFieldValue }) => (
            <Form className='organization-form'>
              {/* Basic Information */}
              <section className='form-section'>
                <h3>Basic Information</h3>
                <div className='form-grid'>
                  <div className='input-group'>
                    <label>
                      Organisation Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field type='text' name='organizationName' disabled />
                    <ErrorMessage
                      name='organizationName'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>
                      Phone Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      type='text'
                      name='phoneNumber'
                      disabled
                      onChange={(e) => {
                        let value = e.target.value;

                        // Automatically add +91 if not present
                        if (!value.startsWith("+91 ")) {
                          value = "+91 " + value.slice(4); // Ensure it starts with +91
                        }

                        // Restrict to 14 characters (including +91)
                        if (value.length > 12) {
                          value = value.slice(0, 14); // Limit the input to 14 characters
                        }

                        setFieldValue("phoneNumber", value); // Update field value
                      }}
                    />
                    <ErrorMessage
                      name='phoneNumber'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>
                      Email Address <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field type='email' name='emailAddress' disabled />
                    <ErrorMessage
                      name='emailAddress'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>No. of Employees</label>
                    <Field type='number' name='numberOfEmployees' />
                    <ErrorMessage
                      name='numberOfEmployees'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>Website URL</label>
                    <Field type='url' name='websiteUrl' />
                    <ErrorMessage
                      name='websiteUrl'
                      component='div'
                      className='error'
                    />
                  </div>
                </div>
              </section>

              {/* Address Information */}
              <section className='form-section'>
                <h3>Address Information</h3>
                <div className='form-grid'>
                  <div className='input-group'>
                    <label>
                      Address Line / Street <span style={{ color: "red" }}> *</span>
                    </label>
                    <Field type='text' name='address' />
                    <ErrorMessage
                      name='address'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>City<span style={{ color: "red" }}>*</span></label>
                    <Field type='text' name='city' />
                    <ErrorMessage
                      name='city'
                      component='div'
                      className='error'
                    />
                  </div>

                  {/* Country Dropdown */}
                  <div className='input-group'>
                    <label>
                      Country <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      as='select'
                      name='country'
                      onChange={(e) => {
                        const countryCode = e.target.value;
                        setFieldValue("country", countryCode);
                        setSelectedCountry(countryCode);
                        setFieldValue("state", "");
                        setFieldValue("district", "");
                        setStates([]);
                        setDistricts([]);
                      }}
                    >
                      <option value=''>Select Country</option>
                      {countries.map((country) => (
                        <option key={country.id || country.countryId} value={country.id || country.countryId}>
                          {country.countryName || country.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name='country'
                      component='div'
                      className='error'
                    />
                  </div>

                  {/* State Dropdown */}
                  <div className='input-group'>
                    <label>
                      State <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      as='select'
                      name='state'
                      onChange={(e) => {
                        const stateCode = e.target.value;
                        setFieldValue("state", stateCode);
                        setSelectedState(stateCode);
                        setFieldValue("district", "");
                        setDistricts([]);
                      }}
                    >
                      <option value=''>Select State</option>
                      {states.map((state) => (
                        <option key={state.id || state.stateId} value={state.id || state.stateId}>
                          {state.countryName || state.stateName || state.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name='state'
                      component='div'
                      className='error'
                    />
                  </div>

                  {/* District Dropdown */}
                  <div className='input-group'>
                    <label>
                      District <span style={{ color: "red" }}>*</span>
                    </label>                    <Field as='select' name='district'>
                      <option value=''>Select District</option>
                      {districts.map((district) => (
                        <option key={district.id || district.districtId} value={district.id || district.districtId}>
                          {district.countryName || district.districtName || district.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name='district'
                      component='div'
                      className='error'
                    />
                  </div>

                  <div className='input-group'>
                    <label>
                      Pincode <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field type='number' name='pincode' />
                    <ErrorMessage
                      name='pincode'
                      component='div'
                      className='error'
                    />
                  </div>
                </div>
              </section>

              {/* Legal and Compliance Information */}
              <section className='form-section'>
                <h3>Legal And Compliance Information</h3>
                <div className='form-grid'>
                  <div className='input-group'>
                    <label>PAN</label>
                    <Field type='text' name='pan' />
                    <ErrorMessage
                      name='pan'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>GSTIN</label>
                    <Field type='text' name='gstin' />
                    <ErrorMessage
                      name='gstin'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>ESI Registration Number</label>
                    <Field type='text' name='esiNumber' />
                    <ErrorMessage
                      name='esiNumber'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>PF Registration Number</label>
                    <Field type='text' name='pfNumber' />
                    <ErrorMessage
                      name='pfNumber'
                      component='div'
                      className='error'
                    />
                  </div>
                </div>
              </section>

              {/* Bank Details */}
              <section className='form-section'>
                <h3>Bank Detail</h3>
                <div className='form-grid'>
                  <div className='input-group'>
                    <label>
                      Bank Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field as='select' name='bankName'>
                      <option value=''>Select Bank</option>
                      {BANK_LIST.map((bank, index) => (
                        <option key={index} value={bank}>
                          {bank}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name='bankName'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>
                      Branch Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field type='text' name='branchName' />
                    <ErrorMessage
                      name='branchName'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>
                      Account Holder Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field type='text' name='accountHolderName' />
                    <ErrorMessage
                      name='accountHolderName'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>
                      Account Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      type='password'
                      name='accountNumber'
                      autoComplete='new-password'
                      onPaste={(e) => e.preventDefault()}
                      onCopy={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      onKeyDown={(e) => {
                        if (
                          (e.ctrlKey || e.metaKey) &&
                          ["c", "v", "x"].includes(e.key.toLowerCase())
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <ErrorMessage
                      name='accountNumber'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>
                      Confirm Account Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      type='text'
                      name='confirmAccountNumber'
                      onPaste={(e) => e.preventDefault()}
                      onCopy={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, "");
                      }}
                    />
                    <ErrorMessage
                      name='confirmAccountNumber'
                      component='div'
                      className='error'
                    />
                  </div>
                  <div className='input-group'>
                    <label>
                      IFSC <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field type='text' name='ifsc' />
                    <ErrorMessage
                      name='ifsc'
                      component='div'
                      className='error'
                    />
                  </div>
                </div>
              </section>

              {/* Submit Button */}
              <button
                type='submit'
                disabled={isSubmitting}
                className='submit-button'
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default OrganizationDetail;
